import { getBrandConfig } from '../../../config/brands'
import { routes } from '../../routes'

export const getStartPage = () => {
  const { brandConfig } = getBrandConfig()

  return brandConfig.startPage || routes.ROUTES_DASHBOARD.dashboard
}
